module.exports = __webpack_public_path__ + "static/media/playstore.48588b47.svg";